var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dragBusinessUnit",style:({top: _vm.posy + 'px', left: _vm.posx + 'px', display: _vm.toggled ? 'inline-block' : 'none'})},[_c('div',{staticClass:"label"},[_vm._v("\n        "+_vm._s(_vm.appendedData.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }